import Icon from '@ahmdigital/icons-web';
import styled from 'styled-components';

export const SearchItem = styled.div<{ isHighlighted: boolean }>`
  align-items: center;
  background-color: ${({ isHighlighted, theme }) => (isHighlighted ? theme.colors.grey10 : theme.colors.white)};
  border-radius: 0.25rem;
  cursor: pointer;
  display: flex;
  font-size: 20px;
  padding: 1rem;

  @media (min-width: ${({ theme }) => theme.media.lg}) {
    min-width: 26.25rem;
  }
`;

export const SearchIcon = styled(Icon)`
  margin-right: 0.5rem;
`;
